import React, { memo } from 'react';
export function TestimonialsSection() {
  const testimonials = [{
    quote: 'I used to take dozens of photos and still feel disappointed. Now I finally know how to capture my dog in a way that actually feels special.',
    name: 'Emily Parker, 34',
    title: 'Dog Mom, Austin, USA'
  }, {
    quote: 'This made dog photography feel simple for the first time. My photos look so much better with just my phone.',
    name: 'Rachel Morgan, 29',
    title: 'Puppy Owner, Miami, USA'
  }, {
    quote: "I bought this because I wanted better memories of my senior dog. It helped me capture moments I'll genuinely treasure forever.",
    name: 'Daniel Foster, 42',
    title: 'Dog Owner, Manchester, UK'
  }, {
    quote: "It's practical, clear, and not overloaded with technical jargon. Exactly what I needed.",
    name: 'Sophie Bennett, 31',
    title: 'Pet Lover, Sydney, Australia'
  }, {
    quote: 'The action photo tips alone were worth it. My dog finally looks as fun in photos as he is in real life.',
    name: 'Laura Jenkins, 27',
    title: 'Golden Retriever Owner, Toronto, Canada'
  }];
  return <section className="bg-white py-20 md:py-32 px-4" data-id="element-222">
      <div className="max-w-5xl mx-auto" data-id="element-223">
        <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl font-bold text-center text-black mb-16 leading-tight" data-id="element-224">
          What dog owners are{' '}
          <span className="italic text-soft-gold" data-id="element-225">saying</span>
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-226">
          {testimonials.map((t, index) => <div key={index} className={`bg-cream p-8 md:p-10 rounded-2xl border border-gray-100 shadow-sm relative ${index === 4 ? 'md:col-span-2 md:max-w-2xl md:mx-auto' : ''}`} data-id="element-227">
              <div className="text-soft-gold text-6xl absolute top-4 left-6 opacity-20 font-serif" data-id="element-228">
                "
              </div>
              <div className="flex text-orange mb-4" data-id="element-229">
                {'★★★★★'.split('').map((star, i) => <span key={i} data-id="element-230">{star}</span>)}
              </div>
              <p className="font-sans text-lg md:text-xl text-gray-800 italic mb-8 relative z-10 leading-relaxed" data-id="element-231">
                "{t.quote}"
              </p>
              <div className="flex items-center" data-id="element-232">
                <div className="w-12 h-12 bg-gray-200 rounded-full flex items-center justify-center text-gray-500 font-bold text-xl mr-4" data-id="element-233">
                  {t.name.charAt(0)}
                </div>
                <div data-id="element-234">
                  <p className="font-sans font-bold text-black" data-id="element-235">{t.name}</p>
                  <p className="font-sans text-sm text-gray-500" data-id="element-236">{t.title}</p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}